<template>
  <button
      @click="onIconClick(accomodation_type)"
      type="button"
      class="room-icon"
      :disabled="disabled"
  >
    <template v-for="(adult, index) in accomodation_type.age_assignment.adult">
      <img v-if="adult" src="@/assets/img/adult-icon.svg" alt="" :key="`adult_${index}`">
    </template>
    <template v-for="(teenager, index) in accomodation_type.age_assignment.teenager">
      <img v-if="teenager" src="@/assets/img/teenager-icon.svg" alt="" :key="`teenager_${index}`">
    </template>
    <template v-for="(child, index) in accomodation_type.age_assignment.child">
      <img v-if="child" src="@/assets/img/child-icon.svg" alt="" :key="`child_${index}`">
    </template>
  </button>
</template>

<script>
export default {
  name: 'AppRoomIcon',
  props: {
    accomodation_type: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onIconClick(type) {
      this.$emit('click', type)
    }
  }
}
</script>

<style lang="sass" scoped>
.room-icon
  display: inline-flex
  align-items: flex-end
  justify-content: center
  gap: 2px
  min-width: 38px
  height: 38px
  padding: 8px
  border: 1px solid rgba(0, 0, 0, 0.1)
  border-radius: 4px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1)
  background: linear-gradient(180deg, #fff 0%, #f4f4f4 100%)
  transition: border 0.3s, background-color 0.3s

  &:hover
    border: 1px solid #bbb
    background-color: #f9f9f9

  &[disabled]
    pointer-events: none

.room-icon__disabled
  opacity: 0.6
</style>